import { Instant } from "@js-joda/core";
import React from "react";
import { AddressComponents } from "../../../messages/Visit";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { getLocationDisplayLocation } from "../../../utils/addressComponentUtils";
import EngagementLabel from "../../Generic/EngagementLabel";
import Flex from "../../Generic/Flex";
import { IsDefined } from "../../Generic/IsDefined";

interface Props {
  addressComponents: AddressComponents | null;
  viewedAt: Instant | null;
}

const AvailableTaskListItemAddressEngagement = (props: Props) => {
  return (
    <Flex justifyContent="space-between" className="AvailableTasksListItem__AddressComponents">
      <IsDefined value={props.addressComponents}>
        {(val) => <span>{getLocationDisplayLocation(val)}</span>}
      </IsDefined>
      <EngagementLabel
        type={props.viewedAt !== null ? "task_viewed" : "task_new"}
        text={props.viewedAt !== null ? translate(STRINGS.VIEWED) : translate(STRINGS.NEW)}
      />
    </Flex>
  );
};

export default AvailableTaskListItemAddressEngagement;
